import { action } from '@reatom/framework'

import { pipe, Result } from '@blade/std-lib'
import { Network, selectedNetworkAtom } from '@root/entities/network'
import { dependenciesAtom } from '@root/features/shared/dependencies'
import { UserTradingAnalyticsPeriod } from '@root/features/user/user-trading-analytics/models'
import { ApiError, apiRequest } from '@root/shared/api'

import type { DistributeRange } from '../model'
import type { UserTokenDistributionCreatePayload } from '@blade/trade-api-client'
import type { DelugeId } from '@root/entities/user-short'

const PERIOD_TO_DTO: Record<
  UserTradingAnalyticsPeriod,
  NonNullable<UserTokenDistributionCreatePayload['period']>
> = {
  [UserTradingAnalyticsPeriod['1H']]: '1H',
  [UserTradingAnalyticsPeriod['6H']]: '6H',
  [UserTradingAnalyticsPeriod['12H']]: '12H',
  [UserTradingAnalyticsPeriod['1D']]: '1D',
  [UserTradingAnalyticsPeriod['7D']]: '7D',
  [UserTradingAnalyticsPeriod.ALL]: 'ALL',
}

export const fetchDistributeRequestAction = action(
  async (
    ctx,
    args: {
      period: UserTradingAnalyticsPeriod
      range: DistributeRange
      delugeId: DelugeId
    },
  ) => {
    const { tradeApiClient } = ctx.get(dependenciesAtom)
    const network = ctx.get(selectedNetworkAtom)

    const result = await ctx.schedule(() =>
      apiRequest(ctx, tradeApiClient.user.userTokenDistributionCreate, [
        {
          delugeId: args.delugeId,
          network: Network.toDto(network),
          period: PERIOD_TO_DTO[args.period],
        },
      ]),
    )

    return pipe(result, Result.mapError(ApiError.fallbackToUnknown))
  },
  'fetchDistributeRequestAction',
)
